export  default {
    getContainerTypes(state) {
        return state.containerTypes;
    },
    getCurrentContainerType(state) {
        return state.currentContainerType;
    },
};